import React from "react";
import { useGameIdFromRoute, useTopicIdFromRoute } from "../games/WithGameIdFromRoute";
import ListItemText from "@mui/material/ListItemText";
import ListItemButton from "@mui/material/ListItemButton";
import { Path } from "../Path";
import { useNavigate } from "react-router-dom";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import { UserAvatar } from "../users/UserAvatar";
import Typography from "@mui/material/Typography";
import { formatTopicDate } from "./model";
import Box from "@mui/material/Box";
import Chip from "@mui/material/Chip";
import { TopicTypeLabels } from "@seabrookstudios/pitch2table-core";

/**
 * @param {number} replies
 * @returns {string}
 */
const formatReplies = (replies) => {
  if (replies === 1) {
    return "1 reply";
  }

  return `${replies} replies`;
};

/**
 * @param {object} props
 * @param {import("@seabrookstudios/pitch2table-core").TopicForApp} props.item
 */
export const TopicListEntry = ({ item }) => {
  const gameId = useGameIdFromRoute();
  const topicId = useTopicIdFromRoute();

  const navigate = useNavigate();

  const selected = topicId === item.id;

  const onClickHandler = () => {
    navigate(Path.game(gameId).topic(item.id));
  };

  return (
    <ListItemButton id={`topic-${item.id}`} alignItems="flex-start" selected={selected} onClick={onClickHandler}>
      <ListItemAvatar>
        <UserAvatar userId={item.lastModifiedByUserId} />
      </ListItemAvatar>
      <ListItemText
        primary={
          <Box display="flex" alignItems="center">
            <Typography variant="inherit" fontWeight="bold">
              {item.name} <Chip component="span" label={TopicTypeLabels[item.type]} size="small" />
            </Typography>
          </Box>
        }
        secondary={
          <Typography variant="inherit">
            {item.preview.length > 0 && (
              <Typography variant="inherit" component="p">
                {item.preview.replaceAll("#", "")}...
              </Typography>
            )}
          </Typography>
        }
      />
      <ListItemAvatar>
        <Typography variant="inherit" component="span">
          {formatTopicDate(item.created)}
        </Typography>
        <Typography variant="inherit" component="p" textAlign="right">
          {item.messages === 1 ? "No replies" : formatReplies(item.messages)}
        </Typography>
      </ListItemAvatar>
    </ListItemButton>
  );
};
